import axios from 'axios';

const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// Dynamic fallbacks to avoid baking in localhost into live builds
export const BASE_URL = isLocal 
  ? (process.env.REACT_APP_BASE_URL) 
  : (process.env.REACT_APP_BASE_URL || window.location.origin);

export const API_URL = isLocal 
  ? (process.env.REACT_APP_API_URL) 
  : (process.env.REACT_APP_API_URL || `${window.location.origin}/api`);


const api = axios.create({
  baseURL: API_URL,
  timeout: 15000, 
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) {
    if (config.headers && typeof config.headers.set === 'function') {
      config.headers.set('Authorization', `Bearer ${token}`);
    } else {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("admin_token");
      localStorage.removeItem("admin_user");
      // Optional: You can redirect to login here if you want
      // window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

export const formatFileUrl = (url) => {
    if (!url || typeof url !== 'string') return '';
    if (url.startsWith('http')) return url;
    // Only prepend BASE_URL for uploaded files
    if (url.startsWith('/uploads')) {
        return `${BASE_URL}${url}`;
    }
    // Return relative paths for public assets (like /assets/...)
    return url;
};

export default api;
